import React, { Component } from "react";
import { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import {
  Button,
  Nav,
  Navbar,
  NavDropdown,
  Form,
  FormControl,
  Table,
  Modal,
  Col,
  Card,
} from "react-bootstrap";
// import firebase from "./Firebase";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
} from "react-router-dom";
import Home from "./Home";
import Taxation from "./Taxation";
import GstRegistration from "./GstRegistration";
import GstReturnFiling from "./GstReturnFiling";
import BusinessRegistration from "./BusinessRegistration";
import TrademarkandCopyrightRegistration from "./TrademarkandCopyrightRegistration";
import CorporateComplince from "./CorporateComplince";
import PersonalLoan from "./PersonalLoan";
import HomeLoan from "./HomeLoan";
import CarLoan from "./CarLoan";
import TwoWheelerLoan from "./TwoWheelerLoan";
import EducationLoan from "./EducationLoan";
import Invest from "./Invest";
import Partner from "./Partner";
import ContactUs from "./ContactUs";
import Insurance from "./Insurance";
import TermLifeInsurance from "./TermLifeInsurance";
import HealthInsurance from "./HealthInsurance";
import InvestmentPlan from "./InvestmentPlan";
import CarInsurance from "./CarInsurance";
import TwoWheelerInsurance from "./TwoWheelerInsurance";
import TravelInsurance from "./TravelInsurance";
import Selfefiling from "./Selfefiling";
import ExpertAssistedefiling from "./ExpertAssistedefiling";
import PremiumAssistedefiling from "./PremiumAssistedefiling";
import ForeignIncomeTaxFiling from "./ForeignIncomeTaxFiling";
import TaxConsultancy from "./TaxConsultancy";
import Accounting from "./Accounting";
import GstAdvisory from "./GstAdvisory";
import GstAudit from "./GstAudit";
import GstAssesment from "./GstAssesment";

export class Navigation extends Component {
  render() {
    return (
      <div>
        <div>
          <Router>
            {/* <nav class="main-nav float-right d-none d-lg-block">
          <ul>
          <li class="active"><a href="index.html">Home</a></li>
          <li><a href="#about">About Us</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#portfolio">Portfolio</a></li>
          <li><a href="#team">Team</a></li>
          <li class="drop-down"><a href="">Drop Down</a>
            <ul>
              <li><a href="#">Drop Down 1</a></li>
              <li class="drop-down"><a href="#">Drop Down 2</a>
                <ul>
                  <li><a href="#">Deep Drop Down 1</a></li>
                  <li><a href="#">Deep Drop Down 2</a></li>
                  <li><a href="#">Deep Drop Down 3</a></li>
                  <li><a href="#">Deep Drop Down 4</a></li>
                  <li><a href="#">Deep Drop Down 5</a></li>
                </ul>
              </li>
              <li><a href="#">Drop Down 3</a></li>
              <li><a href="#">Drop Down 4</a></li>
              <li><a href="#">Drop Down 5</a></li>
            </ul>
          </li>
          <li><a href="#contact">Contact Us</a></li>
        </ul>
        </nav> */}
            {/* <nav class="main-nav float-right d-none d-lg-block">
            <Navbar
              collapseOnSelect
              expand="lg"
              bg="transparent"
              variant="light"
            >
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto" ActiveKey="home-tb">
                  <NavDropdown title="Taxation" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="#action/3.1">
                      Income Tax
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.2">GST</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Compliance" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="#action/3.1">
                      Business Registration
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.2">Trademark and Copyrights</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.2">Corporate Compliances</NavDropdown.Item>
                  </NavDropdown>
                 
                  <Nav.Link href="/home-tb">Mutual Funds</Nav.Link>

                  <Nav.Link href="/home-tb">Insurance</Nav.Link>
                  <Nav.Link href="/home-tb">Equities</Nav.Link>
                  <Nav.Link href="/home-tb">Loans</Nav.Link>
                  <Nav.Link href="/home-tb">Invest</Nav.Link>
                  <Nav.Link href="/home-tb">Partner</Nav.Link>
                  
                </Nav>

               
              </Navbar.Collapse>
            </Navbar>
            </nav> */}
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/taxation">
                <Taxation />
              </Route>
              <Route exact path="/gstregistration">
                <GstRegistration />
              </Route>
              <Route exact path="/gstreturnfiling">
                <GstReturnFiling />
              </Route>
              <Route exact path="/businessregistration">
                <BusinessRegistration />
              </Route>
              <Route exact path="/trademarkandcopyrightregistration">
                <TrademarkandCopyrightRegistration />
              </Route>
              <Route exact path="/corporatecompliance">
                <CorporateComplince />
              </Route>
              <Route exact path="/personalloan">
                <PersonalLoan />
              </Route>
              <Route exact path="/homeloan">
                <HomeLoan />
              </Route>
              <Route exact path="/carloan">
                <CarLoan />
              </Route>
              <Route exact path="/twowheelerloan">
                <TwoWheelerLoan />
              </Route>
              <Route exact path="/educationloan">
                <EducationLoan />
              </Route>
              <Route exact path="/invest">
                <Invest />
              </Route>
              <Route exact path="/partner">
                <Partner />
              </Route>
              <Route exact path="/contactus">
                <ContactUs />
              </Route>
              <Route exact path="/insurance">
                <Insurance />
              </Route>
              <Route exact path="/termlifeinsurance">
                <TermLifeInsurance />
              </Route>
              <Route exact path="/healthinsurance">
                <HealthInsurance />
              </Route>
              <Route exact path="/investmentplan">
                <InvestmentPlan />
              </Route>
              <Route exact path="/carinsurance">
                <CarInsurance />
              </Route>
              <Route exact path="/twowheelerinsurance">
                <TwoWheelerInsurance />
              </Route>
              <Route exact path="/travelinsurance">
                <TravelInsurance />
              </Route>
              <Route exact path="/selfefiling">
                <Selfefiling />
              </Route>
              <Route exact path="/expertassistedefiling">
                <ExpertAssistedefiling />
              </Route>
              <Route exact path="/premiumassistedefiling">
                <PremiumAssistedefiling />
              </Route>
              <Route exact path="/foreignincometaxfiling">
                <ForeignIncomeTaxFiling />
              </Route>
              <Route exact path="/taxconsultancy">
                <TaxConsultancy />
              </Route>
              <Route exact path="/accounting">
                <Accounting />
              </Route>
              <Route exact path="/gstadvisory">
                <GstAdvisory />
              </Route>
              <Route exact path="/gstaudit">
                <GstAudit />
              </Route>
              <Route exact path="/gstassesment">
                <GstAssesment />
              </Route>
            </Switch>
          </Router>
        </div>
      </div>
    );
  }
}

export default Navigation;
